import { ERROR__with_assert_data } from '@shared/asserts/ERROR__with_assert_data';
import { error_to_string } from '@shared/utils/utils_shared_error';
import * as stackTraceParser from 'stacktrace-parser';
import { BuilderLogEntry } from './builder_log_entry';
import { ConstantsLogger } from './constants_logger';
import { ILogMessageParams } from './i_log_message_params';
import { StackTraceLine } from './stack_trace_line';

export class LogEntryError {
  content: string[] = [];
  styles: string[] = [];
  params!: ILogMessageParams;

  /*
   * METHODS
   */

  constructor(message: string, params: ILogMessageParams) {
    this.params = params;

    let log_entry = BuilderLogEntry.build(message, params);
    this.add_line(log_entry.get_log_line());

    this.process_error_object();

    this.try_add_stack_trace();
  }

  private add_line(line: string, color: string = ConstantsLogger.COLOR_ERROR) {
    this.content.push(line);
    this.styles.push(color);
  }

  private process_error_object() {
    let { params } = this;
    let { error } = params;

    if (error == null) return;

    let message_error = error_to_string(error);

    if (message_error) {
      this.add_line('', '');

      this.add_line('ERROR MESSAGE');
      this.add_line(message_error);

      this.add_line('', '');
    }

    if (error instanceof ERROR__with_assert_data) {
      this.add_line('', '');
      this.add_line('ERROR DATA');
      this.add_line(error.assert_type, '');
      this.add_line(JSON.stringify(error.assert_payload), '');
      this.add_line('', '');
    }
  }

  private try_add_stack_trace() {
    let { params } = this;

    if (params.omit_stack_trace) return;

    this.add_line('', '');
    this.add_line('STACKTRACE');

    let stack_lines = this.get_stack_trace_lines(params.error || new Error());

    stack_lines.reverse();

    for (let line of stack_lines) {
      let color = ConstantsLogger.COLOR_ERROR;

      for (let file_name_to_ignore of ConstantsLogger.FILES_TO_IGNORE_ERROR_COLOR_ON_STACKTRACE) {
        if (line.file_path.includes(file_name_to_ignore)) {
          color = ConstantsLogger.COLOR_NOT_IMPORTANT;
          break;
        }
      }

      this.add_line(line.toString(), color);
      this.add_line('', '');
    }
  }

  get_message_pattern() {
    let out: string[] = [];

    for (let content_line of this.content) {
      content_line = `%c${content_line}`;
      out.push(content_line);
    }

    return out.join('\n');
  }

  private get_stack_trace_lines(error: Error): StackTraceLine[] {
    const stack = stackTraceParser.parse(error.stack || '');

    let out: StackTraceLine[] = [];

    for (let frame of stack) {
      let line = new StackTraceLine();

      line.file_path = frame.file || '';
      line.line_number = frame.lineNumber || 0;
      line.column_number = frame.column || 0;
      line.function_name = frame.methodName;

      out.push(line);
    }

    return out;
  }
}
